import { render, staticRenderFns } from "./SiteBanner.vue?vue&type=template&id=59da8a70&"
import script from "./SiteBanner.vue?vue&type=script&lang=js&"
export * from "./SiteBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports